import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=87bbcc7a&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bbcc7a')) {
      api.createRecord('87bbcc7a', component.options)
    } else {
      api.reload('87bbcc7a', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=87bbcc7a&", function () {
      api.rerender('87bbcc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/Switch.vue"
export default component.exports